<template>
  <div class="home cons">
    <div class="logo_wrap">
      <a
        href="https://apps.apple.com/app/jack-rope-runs-season-1/id1524646189?mt=8"
        target="_blank"
      >
      </a>
    </div>
    <Start msg="Let's meet Jack Rope" />
  </div>
</template>

<script>
// @ is an alias to /src
import Start from "@/components/start.vue";

export default {
  name: "home",
  components: {
    Start,
  },
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 100%;
  margin-bottom: -4px;
}

.home.cons {
  margin-top: 30px;
}

.logo_wrap {
  width: 100%;
  background: url("../assets/header_bg_l_0.png");
  background-size: 100% 100%;
  padding: 0;
  margin-top: -20px;
}
</style>
